import type { ChangeEmailInfo } from 'src/api/endpoints/storeApi.types';

export const isExpired = (emailChange: ChangeEmailInfo) => {
  const expires = new Date(emailChange.expiresAt).getTime();
  return expires < Date.now();
};
